module.exports = new __parcel__URL__("pro.8dd4b513.png").toString();